import { render, staticRenderFns } from "./AdvicesList.vue?vue&type=template&id=d1b8ff12&scoped=true&"
import script from "./AdvicesList.vue?vue&type=script&lang=js&"
export * from "./AdvicesList.vue?vue&type=script&lang=js&"
import style0 from "./AdvicesList.vue?vue&type=style&index=0&id=d1b8ff12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1b8ff12",
  null
  
)

export default component.exports